import PropTypes from "prop-types";

const TestimonialCard = ({ img, author, message, position }) => {
    return (
        <div className="w-full rounded-lg shadow-smooth phone:p-6 tablet:p-6 p-8 flex flex-col justify-between">
            <div className="">
                <img src={`/images/homepage/person/${img}.png`} className="w-14 h-14 rounded-full bg-neutral-40 mb-8" alt={img} />
                <p className="text-primary-dark text-[18px] leading-[30.6px] tracking-text font-normal text-basier-circle-regular">{message}</p>
            </div>
            <div className="mt-8 phone:mt-8">
                <h3 className="font-semibold phone:text-[16px] leading-[21.6px] text-primary-dark">{author}</h3>
                <p className="text-sm text-neutral-50 leading-[1.35] font-normal pt-2">{position}</p>
            </div>
        </div>
    );
};

TestimonialCard.propTypes = {
    img: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired
};

export default TestimonialCard;